var DateTimeItem = /** @class */ (function () {
    function DateTimeItem(value, name) {
        this.name = '';
        this.value = value;
        this.name = name;
    }
    return DateTimeItem;
}());
export { DateTimeItem };
